"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeCategory = void 0;
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _TypeDisplayWithHydration = require("./TypeDisplayWithHydration");
const useTypeCategory = _ref => {
  let {
    typeId,
    typeCategoryId
  } = _ref;
  const issueTypeEntitiesMap = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  let categoryId;
  if (typeCategoryId) {
    categoryId = typeCategoryId;
  } else if (typeId && issueTypeEntitiesMap[typeId]) {
    categoryId = issueTypeEntitiesMap[typeId].parentId;
  }
  return (0, _TypeDisplayWithHydration.useIssueTypeEntity)(categoryId);
};
exports.useTypeCategory = useTypeCategory;
//# sourceMappingURL=useTypeCategory.js.map